// src/app/services/invoice.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { saveAs } from 'file-saver';
import { environment } from '../../../assets/environments/environment';
import { UrlReferenceService } from './url-reference.service';
import { PaginatedPolicyResponse } from '../../models/policy.interface';

@Injectable({
  providedIn: 'root',
})
export class InvoiceService {
  private apiUrl = `${environment.backend.employeeManagmentService?.baseApiUrl}/invoices`;

  constructor(private http: HttpClient, private urlRef: UrlReferenceService) {}

  downloadInvoice(policyId: string): Observable<Blob> {
    return this.http.get(
      `${this.urlRef.currentBaseUrl}/invoices/${policyId}/pdf`,
      {
        responseType: 'blob',
      }
    );
  }

  getInvoiceDetails(policyNumber: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/${policyNumber}`);
  }

  getInvoices(userId: string, companyId: number): Observable<PaginatedPolicyResponse> {
    const params = new HttpParams().set('userId', userId).set('companyId', companyId);
    return this.http.get<PaginatedPolicyResponse>(`${this.apiUrl}`, { params });
  }
}
